import { SpecialistPage } from '@features/dashboard/specialistDashboard/specialistProfile/specialistProfilePage';

export const Specialist = () => {
	return <SpecialistPage />;
};
